const getSirenIntervalOfFive = state => {
  const {
    orders: { currentOrderId },
  } = state;

  return !!currentOrderId;
};

export default getSirenIntervalOfFive;



// WEBPACK FOOTER //
// ./src/selectors/get-siren-interval-of-five.js